import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const MyNightPage = lazy(() => import("@/pages/MyNightPage"));

function MyNightFallback() {
  return (
    <div className="relative overflow-y-auto pb-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-glow" />
      <header className="relative px-4 pt-14 pb-4">
        <h1 className="text-3xl font-bold">🌙 Meine Nacht</h1>
      </header>
      <div className="px-4">
        <LoadingBlock label="Deine Nacht wird geladen…" />
      </div>
    </div>
  );
}

function MyNightRoute() {
  return (
    <Suspense fallback={<MyNightFallback />}>
      <MyNightPage />
    </Suspense>
  );
}

export const Route = createFileRoute("/mynight")({
  head: () => ({
    meta: [
      { title: "Meine Nacht · Pulse" },
      { name: "description", content: "Dein Night Roadmap — Events und Venues geplant." },
    ],
  }),
  component: MyNightRoute,
});
